module.exports = __webpack_public_path__ + "img/facebook.769d8706.svg";